import {connect} from "react-redux";
import App from "./App";
import * as authActions from "./actions/AuthActions";
import {getModals, getWindows} from "./reducers/windowsReducer";
import {canReadShipping, canReadSales, canReadInventory, canReadAdmin, canReadNotes} from "./reducers/authReducer";
import {getContextualMenu} from "./reducers/viewReducer";

function mapStateToProps(state) {
  return {
    authenticated: state.getIn(["auth", "authenticated"]),
    windows: getWindows(state.get("windows")),
    modals: getModals(state.get("windows")),
    modalActive: state.getIn(["windows", "modalActive"]),
    contextualMenu: getContextualMenu(state.get("view")),

    canReadAdmin: canReadAdmin(state.get("auth")),
    canReadShipping: canReadShipping(state.get("auth")),
    canReadInventory: canReadInventory(state.get("auth")),
    canReadSales: canReadSales(state.get("auth")),
    canReadNotes: canReadNotes(state.get("auth")),
  }
}

export default connect(mapStateToProps, {...authActions})(App);